import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useApplicationStore = defineStore('app', () => {
  const ready = ref(false);
  const startPageInitializing = ref(true); // Start as true for start page

  function setReady() {
    ready.value = true;
  }

  function setStartPageInitializing(value) {
    startPageInitializing.value = value;
  }

  return {
    ready,
    setReady,
    setStartPageInitializing,
    startPageInitializing,
  };
});
